import { render, staticRenderFns } from "./DrinkRiskLevel.vue?vue&type=template&id=0134d412&scoped=true&"
import script from "./DrinkRiskLevel.vue?vue&type=script&lang=ts&"
export * from "./DrinkRiskLevel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0134d412",
  null
  
)

export default component.exports